// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  max-width: 1000px;
  margin: 0 auto;
  min-height: 100vh;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

@media (max-width: 768px) {
  .App {
    padding: 10px;
  }
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Card Layout System */
.card {
  background: var(--white);
  border-radius: 16px;
  padding: 32px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(123, 159, 126, 0.15);
  border: 1px solid var(--border-light);
}

@media (max-width: 768px) {
  .card {
    padding: 24px 20px;
    border-radius: 12px;
  }
}

/* Legal Alert and Disclaimer Styles */
.legal-alert {
  background-color: var(--warning-yellow);
  border: 2px solid var(--warning-yellow-border);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 25px;
  text-align: center;
}

.legal-alert h2 {
  color: var(--primary-sage-dark);
  margin-bottom: 10px;
  font-size: 1.2rem;
  font-weight: 500;
  text-transform: none;
}

.legal-alert p {
  color: var(--text-secondary);
  font-weight: 400;
}

.legal-warning-banner {
  background-color: var(--primary-sage);
  color: white;
  padding: 12px;
  text-align: center;
  font-weight: 500;
  margin-bottom: 20px;
  border-radius: 8px;
  font-size: 1rem;
  letter-spacing: 0.5px;
}

.disclaimer-banner {
  background-color: var(--warm-cream);
  color: var(--text-secondary);
  padding: 12px;
  text-align: center;
  font-weight: 400;
  margin-bottom: 15px;
  border-radius: 8px;
  border: 1px solid var(--accent-gold);
}

.legal-footnote {
  background-color: var(--light-gray);
  border-top: 1px solid var(--border-light);
  padding: 10px;
  margin-top: 15px;
  font-size: 0.85rem;
  color: var(--text-secondary);
  text-align: center;
  width: 100%;
  max-width: 600px;
  border-radius: 0 0 8px 8px;
}

.legal-disclaimer-box {
  background-color: var(--light-gray);
  border: 1px solid var(--border-light);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: var(--shadow-soft);
}

.legal-disclaimer-box h3 {
  color: var(--primary-sage-dark);
  margin-bottom: 12px;
  font-size: 1.1rem;
  font-weight: 500;
}

.legal-disclaimer-box ul {
  padding-left: 20px;
}

.legal-disclaimer-box li {
  margin-bottom: 5px;
  font-weight: 500;
}

.consent-checkbox, .download-agreement {
  margin: 24px 0;
  padding: 20px;
  background-color: rgba(123, 159, 126, 0.05);
  border-radius: 12px;
  border: 1px solid var(--border-light);
}

.agree-box {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
}

.agree-box input {
  margin-right: 10px;
  margin-top: 5px;
}

.next-steps-section {
  background-color: rgba(123, 159, 126, 0.08);
  border-radius: 12px;
  padding: 20px;
  margin: 24px 0;
  border: 1px solid var(--border-light);
}

.next-steps-section h3 {
  color: var(--primary-sage-dark);
  margin-bottom: 12px;
  font-weight: 500;
}

.next-steps-section ol {
  padding-left: 20px;
}

.next-steps-section li {
  margin-bottom: 8px;
}

.scenario-label {
  font-size: 0.8rem;
  color: var(--text-secondary);
  text-transform: uppercase;
  margin-bottom: 8px;
  font-weight: 500;
}

.hypothetical-label {
  font-size: 0.7rem;
  color: var(--text-secondary);
  text-transform: uppercase;
  margin-bottom: 8px;
  font-weight: 500;
  letter-spacing: 0.5px;
  background-color: rgba(123, 159, 126, 0.1);
  display: inline-block;
  padding: 6px 12px;
  border-radius: 8px;
}

.question-discussion {
  background-color: var(--light-gray);
  border-left: 3px solid var(--primary-sage);
  padding: 16px;
  margin: 20px 0;
  font-style: italic;
  color: var(--text-secondary);
  border-radius: 0 8px 8px 0;
}

/* Welcome Component Styles */
h1 {
  margin-bottom: 20px;
  color: var(--primary-sage-dark);
}

/* Primary Button */
.primary-button, button {
  background: linear-gradient(135deg, var(--material-green) 0%, var(--material-green-dark) 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px 32px;
  font-weight: 500;
  font-size: 16px;
  font-family: 'Inter', sans-serif;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  margin: 10px 5px;
}

.primary-button:hover, button:hover {
  background: linear-gradient(135deg, var(--material-green-dark) 0%, var(--material-green-darker) 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(123, 159, 126, 0.35);
}

/* Answer Buttons (Yes/No) */
.answer-button {
  border: 2px solid var(--primary-sage);
  background: white;
  color: var(--primary-sage);
  border-radius: 12px;
  padding: 20px 40px;
  font-size: 18px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  min-width: 120px;
  transition: all 0.2s ease;
  cursor: pointer;
  margin: 5px;
}

.answer-button:hover {
  background: var(--primary-sage);
  color: white;
  transform: none;
}

.answer-button.selected {
  background: var(--primary-sage);
  color: white;
}

@media (max-width: 768px) {
  .answer-button {
    width: 100%;
    padding: 16px;
    margin: 6px 0;
  }
}

.welcome-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 32px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(123, 159, 126, 0.25);
  border: 1px solid rgba(76, 175, 80, 0.2);
  text-align: left;
  backdrop-filter: blur(10px);
}

.welcome-header {
  text-align: center;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--border-light);
}

.welcome-header h1 {
  font-size: 2.5rem;
  font-weight: 300;
  margin-bottom: 12px;
  color: var(--primary-sage-dark);
  line-height: 1.2;
}

.welcome-tagline {
  font-size: 1.2rem;
  color: var(--text-secondary);
  font-weight: 400;
  margin-top: 8px;
}

.welcome-content {
  margin-bottom: 30px;
}

.purpose-section, .disclaimer-section {
  margin-bottom: 32px;
  background-color: var(--white);
  padding: 24px;
  border-radius: 12px;
  box-shadow: var(--shadow-soft);
  border: 1px solid var(--border-light);
}

.purpose-section h2, .disclaimer-section h2 {
  color: var(--primary-sage-dark);
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-light);
}

.purpose-section p {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 16px;
  font-size: 1rem;
}

.disclaimer-section ul {
  padding-left: 20px;
}

.disclaimer-section li {
  color: var(--text-secondary);
  margin-bottom: 12px;
  line-height: 1.6;
}

.disclaimer-section strong {
  color: var(--primary-sage-dark);
  font-weight: 600;
}

.welcome-action {
  text-align: center;
  margin-top: 30px;
}

.begin-button {
  background: linear-gradient(135deg, var(--material-green) 0%, var(--material-green-dark) 100%);
  color: white;
  font-size: 1.2rem;
  padding: 16px 32px;
  border-radius: 12px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  letter-spacing: 0.5px;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.3);
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
}

.begin-button:hover {
  background: linear-gradient(135deg, var(--material-green-dark) 0%, var(--material-green-darker) 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(123, 159, 126, 0.4);
}

.begin-button.disabled {
  background: #95a5a6;
  cursor: not-allowed;
  opacity: 0.7;
  transform: none;
}

.begin-button.disabled:hover {
  background: #95a5a6;
  transform: none;
  box-shadow: 0 2px 4px rgba(123, 159, 126, 0.2);
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .welcome-container {
    padding: 24px 20px;
    border-radius: 12px;
    margin: 0 4px;
  }
  
  .welcome-header h1 {
    font-size: 2rem;
  }
  
  .welcome-tagline {
    font-size: 1rem;
  }
  
  .purpose-section, .disclaimer-section {
    padding: 20px;
  }
  
  .begin-button {
    width: 100%;
    padding: 16px 24px;
    font-size: 1.1rem;
  }
  
  /* Question flow mobile styles */
  .question-flow {
    padding: 20px 4px;
  }
  
  .category-header-container {
    padding: 12px 8px;
    margin-bottom: 16px;
    min-height: 44px;
  }
  
  .category-title {
    font-size: 1.2rem;
    padding: 0 40px;
    min-height: 36px;
  }
  
  /* Adjust both buttons for mobile */
  .back-button, .reset-button {
    width: 32px;
    height: 32px;
    font-size: 1rem;
  }
  
  .back-button {
    left: 8px;
  }
  
  .reset-button {
    right: 8px;
  }
  
  .question-card {
    padding: 24px 20px;
    margin-bottom: 20px;
    min-height: 450px;
    max-height: 80vh;
  }
  
  .summary-container {
    padding: 24px 20px;
    margin: 0 4px;
  }
}

/* Trust Indicators */
.trust-indicators {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin: 24px 0;
  padding: 16px;
  background-color: rgba(123, 159, 126, 0.05);
  border-radius: 8px;
  border: 1px solid var(--border-light);
}

.trust-item {
  font-size: 0.9rem;
  color: var(--text-secondary);
  text-align: center;
  flex: 1 1;
}

@media (max-width: 768px) {
  .trust-indicators {
    flex-direction: column;
    gap: 12px;
  }
}

/* QuestionFlow Component Styles */
.question-flow {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  max-width: 1000px;
  width: 100%;
  position: relative;
}

.question-header {
  width: 100%;
  margin-bottom: 20px;
  max-width: 700px;
}

.category-header-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary-sage-light) 0%, var(--primary-sage) 100%);
  border-radius: 16px;
  padding: 16px 12px;
  box-shadow: 0 4px 16px rgba(123, 159, 126, 0.25);
  border: 1px solid var(--primary-sage);
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  min-height: 48px;
  max-width: 700px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.category-title {
  margin: 0;
  flex: 1 1;
  font-size: 1.35rem;
  color: var(--white);
  text-align: center;
  font-weight: 500;
  padding: 0 40px;
  white-space: normal;
  line-height: 1.3;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* Base styles for navigation buttons */
.back-button, .reset-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  color: var(--primary-sage-dark);
  font-size: 1.2rem;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 0;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 2;
  margin-top: -1px;
}

/* Position the back button on the left */
.back-button {
  left: 10px;
}

/* Position the reset button on the right */
.reset-button {
  right: 10px;
}

/* Hover effects for both buttons */
.back-button:hover, .reset-button:hover {
  background: var(--white);
  color: var(--primary-sage-dark);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transform: translateY(-50%);
}

/* Fix vertical alignment of button icons */
.back-button span, .reset-button span {
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.question-card {
  background: var(--white);
  border-radius: 16px;
  box-shadow: 0 6px 24px rgba(123, 159, 126, 0.18);
  border: 1px solid var(--border-light);
  padding: 32px;
  margin-bottom: 24px;
  width: 100%;
  max-width: 700px;
  min-height: 500px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.question-text {
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--primary-sage-dark);
  margin-bottom: 24px;
  line-height: 1.5;
}

.question-content {
  flex: 1 1;
  overflow-y: auto;
  margin-bottom: 24px;
}

.question-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 0;
  margin-top: auto;
}

@media (max-width: 768px) {
  .question-buttons {
    flex-direction: column;
    gap: 12px;
  }
}

.question-terms {
  background-color: rgba(123, 159, 126, 0.08);
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  text-align: left;
  border: 1px solid var(--border-light);
}

.question-terms h4 {
  margin-top: 0;
  color: var(--primary-sage-dark);
  font-weight: 500;
}

.question-terms ul {
  list-style-type: none;
  padding-left: 0;
}

.question-terms li {
  margin-bottom: 8px;
}

.question-progress {
  margin-top: 24px;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

/* Summary Component Styles */
.summary-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 32px;
  text-align: left;
  background: var(--white);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(123, 159, 126, 0.2);
  border: 1px solid var(--border-light);
  position: relative;
}

.summary-header {
  width: 100%;
  margin-bottom: 20px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

/* We've replaced summary-title-row with category-header-container */

/* We're now using .category-title for all headers */

.summary-intro {
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 24px;
  color: var(--text-secondary);
}

.download-container {
  text-align: center;
  margin: 25px 0 30px;
  width: 100%;
}

.pdf-button {
  background: linear-gradient(135deg, var(--material-green) 0%, var(--material-green-dark) 100%);
  color: white;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 1rem;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.3);
  transition: all 0.3s ease;
  display: inline-block;
  margin: 0 auto;
  border: none;
  cursor: pointer;
}

.pdf-button:hover {
  background: linear-gradient(135deg, var(--material-green-dark) 0%, var(--material-green-darker) 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(123, 159, 126, 0.4);
}

.pdf-button.disabled {
  background: #95a5a6;
  cursor: not-allowed;
  opacity: 0.7;
}

.pdf-button.disabled:hover {
  background: #95a5a6;
  transform: none;
  box-shadow: 0 2px 4px rgba(123, 159, 126, 0.2);
}

.recommendations-container {
  margin-top: 30px;
}

.category-section {
  margin-bottom: 30px;
}

.category-section h2 {
  color: var(--primary-sage-dark);
  font-weight: 500;
  border-bottom: 1px solid var(--border-light);
  padding-bottom: 12px;
  margin-bottom: 20px;
}

.recommendation-item {
  background: var(--white);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: var(--shadow-soft);
  border: 1px solid var(--border-light);
}

.recommendation-item .question-text {
  font-size: 1rem;
  font-weight: 500;
  color: var(--primary-sage-dark);
  margin-bottom: 12px;
  line-height: 1.4;
}

.answer-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.answer-label {
  font-weight: 500;
  margin-right: 10px;
}

.answer-value {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 15px;
  font-weight: bold;
}

.answer-value.yes {
  background-color: rgba(123, 159, 126, 0.2);
  color: var(--primary-sage-dark);
}

.answer-value.no {
  background-color: rgba(107, 107, 107, 0.15);
  color: var(--warm-gray);
}

.recommendation-text {
  font-size: 0.9rem;
  line-height: 1.5;
  padding: 12px;
  background-color: rgba(123, 159, 126, 0.05);
  border-radius: 8px;
  color: var(--warm-gray);
}

.summary-footer {
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid var(--border-light);
  font-size: 0.9rem;
  color: var(--text-secondary);
}

/* Start over button styling now handled by reset-button */`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kHAAkH;AACpH;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,uBAAuB;AACvB;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,sCAAsC;AACtC;EACE,uCAAuC;EACvC,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;EAC1C,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,8FAA8F;EAC9F,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,6CAA6C;EAC7C,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qGAAqG;EACrG,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,iDAAiD;EACjD,wCAAwC;EACxC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8FAA8F;EAC9F,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qGAAqG;EACrG,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,8CAA8C;AAChD;;AAEA,6BAA6B;AAC7B;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,gCAAgC;EAChC;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA,mCAAmC;EACnC;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2FAA2F;EAC3F,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;EAChD,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,+BAA+B;EAC/B,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,UAAU;EACV,yBAAyB;EACzB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,UAAU;AACZ;;AAEA,2CAA2C;AAC3C;EACE,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA,2CAA2C;AAC3C;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gDAAgD;EAChD,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,+CAA+C;EAC/C,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oEAAoE;;AAEpE,oDAAoD;;AAEpD;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,8FAA8F;EAC9F,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qGAAqG;EACrG,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,0DAA0D","sourcesContent":[".App {\n  text-align: center;\n  max-width: 1000px;\n  margin: 0 auto;\n  min-height: 100vh;\n  padding: 40px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n}\n\n@media (max-width: 768px) {\n  .App {\n    padding: 10px;\n  }\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Card Layout System */\n.card {\n  background: var(--white);\n  border-radius: 16px;\n  padding: 32px;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 20px rgba(123, 159, 126, 0.15);\n  border: 1px solid var(--border-light);\n}\n\n@media (max-width: 768px) {\n  .card {\n    padding: 24px 20px;\n    border-radius: 12px;\n  }\n}\n\n/* Legal Alert and Disclaimer Styles */\n.legal-alert {\n  background-color: var(--warning-yellow);\n  border: 2px solid var(--warning-yellow-border);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 25px;\n  text-align: center;\n}\n\n.legal-alert h2 {\n  color: var(--primary-sage-dark);\n  margin-bottom: 10px;\n  font-size: 1.2rem;\n  font-weight: 500;\n  text-transform: none;\n}\n\n.legal-alert p {\n  color: var(--text-secondary);\n  font-weight: 400;\n}\n\n.legal-warning-banner {\n  background-color: var(--primary-sage);\n  color: white;\n  padding: 12px;\n  text-align: center;\n  font-weight: 500;\n  margin-bottom: 20px;\n  border-radius: 8px;\n  font-size: 1rem;\n  letter-spacing: 0.5px;\n}\n\n.disclaimer-banner {\n  background-color: var(--warm-cream);\n  color: var(--text-secondary);\n  padding: 12px;\n  text-align: center;\n  font-weight: 400;\n  margin-bottom: 15px;\n  border-radius: 8px;\n  border: 1px solid var(--accent-gold);\n}\n\n.legal-footnote {\n  background-color: var(--light-gray);\n  border-top: 1px solid var(--border-light);\n  padding: 10px;\n  margin-top: 15px;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  text-align: center;\n  width: 100%;\n  max-width: 600px;\n  border-radius: 0 0 8px 8px;\n}\n\n.legal-disclaimer-box {\n  background-color: var(--light-gray);\n  border: 1px solid var(--border-light);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n  box-shadow: var(--shadow-soft);\n}\n\n.legal-disclaimer-box h3 {\n  color: var(--primary-sage-dark);\n  margin-bottom: 12px;\n  font-size: 1.1rem;\n  font-weight: 500;\n}\n\n.legal-disclaimer-box ul {\n  padding-left: 20px;\n}\n\n.legal-disclaimer-box li {\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.consent-checkbox, .download-agreement {\n  margin: 24px 0;\n  padding: 20px;\n  background-color: rgba(123, 159, 126, 0.05);\n  border-radius: 12px;\n  border: 1px solid var(--border-light);\n}\n\n.agree-box {\n  display: flex;\n  align-items: flex-start;\n  cursor: pointer;\n}\n\n.agree-box input {\n  margin-right: 10px;\n  margin-top: 5px;\n}\n\n.next-steps-section {\n  background-color: rgba(123, 159, 126, 0.08);\n  border-radius: 12px;\n  padding: 20px;\n  margin: 24px 0;\n  border: 1px solid var(--border-light);\n}\n\n.next-steps-section h3 {\n  color: var(--primary-sage-dark);\n  margin-bottom: 12px;\n  font-weight: 500;\n}\n\n.next-steps-section ol {\n  padding-left: 20px;\n}\n\n.next-steps-section li {\n  margin-bottom: 8px;\n}\n\n.scenario-label {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.hypothetical-label {\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  margin-bottom: 8px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  background-color: rgba(123, 159, 126, 0.1);\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 8px;\n}\n\n.question-discussion {\n  background-color: var(--light-gray);\n  border-left: 3px solid var(--primary-sage);\n  padding: 16px;\n  margin: 20px 0;\n  font-style: italic;\n  color: var(--text-secondary);\n  border-radius: 0 8px 8px 0;\n}\n\n/* Welcome Component Styles */\nh1 {\n  margin-bottom: 20px;\n  color: var(--primary-sage-dark);\n}\n\n/* Primary Button */\n.primary-button, button {\n  background: linear-gradient(135deg, var(--material-green) 0%, var(--material-green-dark) 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  padding: 16px 32px;\n  font-weight: 500;\n  font-size: 16px;\n  font-family: 'Inter', sans-serif;\n  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.3);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  display: inline-block;\n  text-decoration: none;\n  margin: 10px 5px;\n}\n\n.primary-button:hover, button:hover {\n  background: linear-gradient(135deg, var(--material-green-dark) 0%, var(--material-green-darker) 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(123, 159, 126, 0.35);\n}\n\n/* Answer Buttons (Yes/No) */\n.answer-button {\n  border: 2px solid var(--primary-sage);\n  background: white;\n  color: var(--primary-sage);\n  border-radius: 12px;\n  padding: 20px 40px;\n  font-size: 18px;\n  font-weight: 500;\n  font-family: 'Inter', sans-serif;\n  min-width: 120px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  margin: 5px;\n}\n\n.answer-button:hover {\n  background: var(--primary-sage);\n  color: white;\n  transform: none;\n}\n\n.answer-button.selected {\n  background: var(--primary-sage);\n  color: white;\n}\n\n@media (max-width: 768px) {\n  .answer-button {\n    width: 100%;\n    padding: 16px;\n    margin: 6px 0;\n  }\n}\n\n.welcome-container {\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 32px;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 16px;\n  box-shadow: 0 12px 40px rgba(123, 159, 126, 0.25);\n  border: 1px solid rgba(76, 175, 80, 0.2);\n  text-align: left;\n  backdrop-filter: blur(10px);\n}\n\n.welcome-header {\n  text-align: center;\n  margin-bottom: 32px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.welcome-header h1 {\n  font-size: 2.5rem;\n  font-weight: 300;\n  margin-bottom: 12px;\n  color: var(--primary-sage-dark);\n  line-height: 1.2;\n}\n\n.welcome-tagline {\n  font-size: 1.2rem;\n  color: var(--text-secondary);\n  font-weight: 400;\n  margin-top: 8px;\n}\n\n.welcome-content {\n  margin-bottom: 30px;\n}\n\n.purpose-section, .disclaimer-section {\n  margin-bottom: 32px;\n  background-color: var(--white);\n  padding: 24px;\n  border-radius: 12px;\n  box-shadow: var(--shadow-soft);\n  border: 1px solid var(--border-light);\n}\n\n.purpose-section h2, .disclaimer-section h2 {\n  color: var(--primary-sage-dark);\n  font-size: 1.5rem;\n  font-weight: 500;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.purpose-section p {\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin-bottom: 16px;\n  font-size: 1rem;\n}\n\n.disclaimer-section ul {\n  padding-left: 20px;\n}\n\n.disclaimer-section li {\n  color: var(--text-secondary);\n  margin-bottom: 12px;\n  line-height: 1.6;\n}\n\n.disclaimer-section strong {\n  color: var(--primary-sage-dark);\n  font-weight: 600;\n}\n\n.welcome-action {\n  text-align: center;\n  margin-top: 30px;\n}\n\n.begin-button {\n  background: linear-gradient(135deg, var(--material-green) 0%, var(--material-green-dark) 100%);\n  color: white;\n  font-size: 1.2rem;\n  padding: 16px 32px;\n  border-radius: 12px;\n  font-weight: 500;\n  font-family: 'Inter', sans-serif;\n  letter-spacing: 0.5px;\n  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.3);\n  transition: all 0.3s ease;\n  border: none;\n  cursor: pointer;\n}\n\n.begin-button:hover {\n  background: linear-gradient(135deg, var(--material-green-dark) 0%, var(--material-green-darker) 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(123, 159, 126, 0.4);\n}\n\n.begin-button.disabled {\n  background: #95a5a6;\n  cursor: not-allowed;\n  opacity: 0.7;\n  transform: none;\n}\n\n.begin-button.disabled:hover {\n  background: #95a5a6;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(123, 159, 126, 0.2);\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  .welcome-container {\n    padding: 24px 20px;\n    border-radius: 12px;\n    margin: 0 4px;\n  }\n  \n  .welcome-header h1 {\n    font-size: 2rem;\n  }\n  \n  .welcome-tagline {\n    font-size: 1rem;\n  }\n  \n  .purpose-section, .disclaimer-section {\n    padding: 20px;\n  }\n  \n  .begin-button {\n    width: 100%;\n    padding: 16px 24px;\n    font-size: 1.1rem;\n  }\n  \n  /* Question flow mobile styles */\n  .question-flow {\n    padding: 20px 4px;\n  }\n  \n  .category-header-container {\n    padding: 12px 8px;\n    margin-bottom: 16px;\n    min-height: 44px;\n  }\n  \n  .category-title {\n    font-size: 1.2rem;\n    padding: 0 40px;\n    min-height: 36px;\n  }\n  \n  /* Adjust both buttons for mobile */\n  .back-button, .reset-button {\n    width: 32px;\n    height: 32px;\n    font-size: 1rem;\n  }\n  \n  .back-button {\n    left: 8px;\n  }\n  \n  .reset-button {\n    right: 8px;\n  }\n  \n  .question-card {\n    padding: 24px 20px;\n    margin-bottom: 20px;\n    min-height: 450px;\n    max-height: 80vh;\n  }\n  \n  .summary-container {\n    padding: 24px 20px;\n    margin: 0 4px;\n  }\n}\n\n/* Trust Indicators */\n.trust-indicators {\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  margin: 24px 0;\n  padding: 16px;\n  background-color: rgba(123, 159, 126, 0.05);\n  border-radius: 8px;\n  border: 1px solid var(--border-light);\n}\n\n.trust-item {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  text-align: center;\n  flex: 1;\n}\n\n@media (max-width: 768px) {\n  .trust-indicators {\n    flex-direction: column;\n    gap: 12px;\n  }\n}\n\n/* QuestionFlow Component Styles */\n.question-flow {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  max-width: 1000px;\n  width: 100%;\n  position: relative;\n}\n\n.question-header {\n  width: 100%;\n  margin-bottom: 20px;\n  max-width: 700px;\n}\n\n.category-header-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--primary-sage-light) 0%, var(--primary-sage) 100%);\n  border-radius: 16px;\n  padding: 16px 12px;\n  box-shadow: 0 4px 16px rgba(123, 159, 126, 0.25);\n  border: 1px solid var(--primary-sage);\n  margin-bottom: 20px;\n  position: relative;\n  overflow: hidden;\n  min-height: 48px;\n  max-width: 700px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.category-title {\n  margin: 0;\n  flex: 1;\n  font-size: 1.35rem;\n  color: var(--white);\n  text-align: center;\n  font-weight: 500;\n  padding: 0 40px;\n  white-space: normal;\n  line-height: 1.3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n/* Base styles for navigation buttons */\n.back-button, .reset-button {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.9);\n  color: var(--primary-sage-dark);\n  font-size: 1.2rem;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  padding: 0;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 2;\n  margin-top: -1px;\n}\n\n/* Position the back button on the left */\n.back-button {\n  left: 10px;\n}\n\n/* Position the reset button on the right */\n.reset-button {\n  right: 10px;\n}\n\n/* Hover effects for both buttons */\n.back-button:hover, .reset-button:hover {\n  background: var(--white);\n  color: var(--primary-sage-dark);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  transform: translateY(-50%);\n}\n\n/* Fix vertical alignment of button icons */\n.back-button span, .reset-button span {\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.question-card {\n  background: var(--white);\n  border-radius: 16px;\n  box-shadow: 0 6px 24px rgba(123, 159, 126, 0.18);\n  border: 1px solid var(--border-light);\n  padding: 32px;\n  margin-bottom: 24px;\n  width: 100%;\n  max-width: 700px;\n  min-height: 500px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.question-text {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: var(--primary-sage-dark);\n  margin-bottom: 24px;\n  line-height: 1.5;\n}\n\n.question-content {\n  flex: 1;\n  overflow-y: auto;\n  margin-bottom: 24px;\n}\n\n.question-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  padding: 0;\n  margin-top: auto;\n}\n\n@media (max-width: 768px) {\n  .question-buttons {\n    flex-direction: column;\n    gap: 12px;\n  }\n}\n\n.question-terms {\n  background-color: rgba(123, 159, 126, 0.08);\n  border-radius: 8px;\n  padding: 16px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  text-align: left;\n  border: 1px solid var(--border-light);\n}\n\n.question-terms h4 {\n  margin-top: 0;\n  color: var(--primary-sage-dark);\n  font-weight: 500;\n}\n\n.question-terms ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.question-terms li {\n  margin-bottom: 8px;\n}\n\n.question-progress {\n  margin-top: 24px;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n/* Summary Component Styles */\n.summary-container {\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 32px;\n  text-align: left;\n  background: var(--white);\n  border-radius: 16px;\n  box-shadow: 0 8px 32px rgba(123, 159, 126, 0.2);\n  border: 1px solid var(--border-light);\n  position: relative;\n}\n\n.summary-header {\n  width: 100%;\n  margin-bottom: 20px;\n  max-width: 700px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* We've replaced summary-title-row with category-header-container */\n\n/* We're now using .category-title for all headers */\n\n.summary-intro {\n  font-size: 1rem;\n  line-height: 1.6;\n  margin-bottom: 24px;\n  color: var(--text-secondary);\n}\n\n.download-container {\n  text-align: center;\n  margin: 25px 0 30px;\n  width: 100%;\n}\n\n.pdf-button {\n  background: linear-gradient(135deg, var(--material-green) 0%, var(--material-green-dark) 100%);\n  color: white;\n  font-weight: 500;\n  font-family: 'Inter', sans-serif;\n  padding: 16px 32px;\n  border-radius: 12px;\n  font-size: 1rem;\n  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.3);\n  transition: all 0.3s ease;\n  display: inline-block;\n  margin: 0 auto;\n  border: none;\n  cursor: pointer;\n}\n\n.pdf-button:hover {\n  background: linear-gradient(135deg, var(--material-green-dark) 0%, var(--material-green-darker) 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(123, 159, 126, 0.4);\n}\n\n.pdf-button.disabled {\n  background: #95a5a6;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.pdf-button.disabled:hover {\n  background: #95a5a6;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(123, 159, 126, 0.2);\n}\n\n.recommendations-container {\n  margin-top: 30px;\n}\n\n.category-section {\n  margin-bottom: 30px;\n}\n\n.category-section h2 {\n  color: var(--primary-sage-dark);\n  font-weight: 500;\n  border-bottom: 1px solid var(--border-light);\n  padding-bottom: 12px;\n  margin-bottom: 20px;\n}\n\n.recommendation-item {\n  background: var(--white);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 16px;\n  box-shadow: var(--shadow-soft);\n  border: 1px solid var(--border-light);\n}\n\n.recommendation-item .question-text {\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--primary-sage-dark);\n  margin-bottom: 12px;\n  line-height: 1.4;\n}\n\n.answer-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.answer-label {\n  font-weight: 500;\n  margin-right: 10px;\n}\n\n.answer-value {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 15px;\n  font-weight: bold;\n}\n\n.answer-value.yes {\n  background-color: rgba(123, 159, 126, 0.2);\n  color: var(--primary-sage-dark);\n}\n\n.answer-value.no {\n  background-color: rgba(107, 107, 107, 0.15);\n  color: var(--warm-gray);\n}\n\n.recommendation-text {\n  font-size: 0.9rem;\n  line-height: 1.5;\n  padding: 12px;\n  background-color: rgba(123, 159, 126, 0.05);\n  border-radius: 8px;\n  color: var(--warm-gray);\n}\n\n.summary-footer {\n  margin-top: 40px;\n  padding-top: 24px;\n  border-top: 1px solid var(--border-light);\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n}\n\n/* Start over button styling now handled by reset-button */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
